module.exports = __webpack_public_path__ + "img/heart.1bd0abfe.png";